enum AssetClass {
  FUTURE = 'FUTURE',
  OPTION = 'OPTION',
  PERP = 'PERPETUAL',
  INDICES = 'INDICES',
}

export default AssetClass
